import React from "react";
import { Header_panel } from "../Useful/Useful";
import { Button, Form } from "reactstrap";
import "../Useful/useful.css";
// import AddSetting from "../Setting/Add_setting";
import "./category.css";
import Addimage from "../../../src/image-add.png";
import { ModalDetailAds } from "../Useful/Useful";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  AdsDelete,
  AdsGetAll,
  TownsGetByProvinceId,
  ProvincegGetAll,
  getAdvertismentByTownId,
  getAdvertismentByTownId2,
  TownsGetAll,
  SearchAdsByProvinceId,
  SearchAdsprovince,
  SettingCreate,
  SettingDelete,
  SettingGetById,
  SettingUpdate,
  UploadFile,
  SearchAds,
  SearchConfirmAds,
  Adsconfirm,
} from "../../fetch";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

export default class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      existData: {},
      error: null,
      data: [],
      isAdd: true,
      isEdit: false,
      page: 0,
      rowsPerPage: 20,
      loading: false,
      datalength: 0,
      name: "",
      isConfirm: false,
      isNotConfirm: false,
      towns: [],
      townId: "",
      provinces: [],
      provinceId: "",
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    this.getList();
    this.getProvinces();
  }

  getProvinces = () => {
    ProvincegGetAll()
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.success) {
          this.setState({ loading: false });
          this.setState({
            provinces: response.result,
            // datalength: response.count,
          });
        } else {
          console.log(response.message);
          this.setState({ loading: true });
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: true });
        toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
      });
  };
  getTowns = () => {
    TownsGetByProvinceId(this.state.provinceId)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.success) {
          this.setState({ loading: false });
          this.setState({
            towns: response.result,
            datalength: response.count,
          });
        } else {
          console.log(response.message);
          this.setState({ loading: true });
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: true });
        toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
      });
  };

  confirmAdss = () => {
    this.setState({ loading: true });
    Adsconfirm({
      IsDone: this.state.isDone,
      IsNotDone: this.state.isNotDone,
      From: this.state.start,
      To: this.state.end,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.success) {
          this.setState({ loading: false });
          this.setState({ data: response.result, datalength: response.count });
        } else {
          this.setState({ loading: true });
          console.log(response.message);
          toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
        }
        return null;
      })
      .catch((error) => {
        this.setState({ loading: true });
        console.log(error);
        toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
        return null;
      });
  };
  getrequest = () => {
    this.setState({ loading: true });
    getAdvertismentByTownId(
      this.state.townId,
      this.state.page,
      this.state.rowsPerPage
    )
      .then((response) => {
        this.setState({ loading: false });

        return response.json();
      })
      .then((responseJson) => {
        this.setState({ data: responseJson.result });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };
  getAdsByProvince = () => {
    this.setState({ loading: true });

    SearchAdsByProvinceId(this.state.page, this.state.rowsPerPage, {
      Description: "",
      Title: "",
      ProvinceId: this.state.provinceId,
    })
      .then((response) => {
        this.setState({ loading: false });

        return response.json();
      })
      .then((responseJson) => {
        this.setState({
          data: responseJson.result,
          datalength: responseJson.count,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };
  getList = () => {
    if (this.state.name) {
      if (this.state.provinceId == "") {
        toast.error("لطفا استان را انتخاب کنید");
        this.setState({ name: "" });
        return;
      }
      if (this.state.townId) {
        this.setState({ loading: true });
        SearchAds(this.state.page, this.state.rowsPerPage, {
          Description: this.state.name,
          Title: this.state.name,
          TownId: this.state.townId,
          ProvinceId: this.state.provinceId,
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.success) {
              this.setState({ name: "" });
              this.setState({ loading: false });
              this.setState({ data: response.result });
            } else {
              this.setState({ loading: false });
              this.setState({ name: "" });
              console.log(response.message);
              toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
            }
            return null;
          })
          .catch((error) => {
            this.setState({ loading: true });
            console.log(error);
            toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
            return null;
          });
      } else {
        this.setState({ loading: true });
        SearchAdsprovince(this.state.page, this.state.rowsPerPage, {
          Description: this.state.name,
          Title: this.state.name,

          ProvinceId: this.state.provinceId,
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.success) {
              this.setState({ name: "" });
              this.setState({ loading: false });
              this.setState({ data: response.result });
            } else {
              this.setState({ loading: false });
              this.setState({ name: "" });
              console.log(response.message);
              toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
            }
            return null;
          })
          .catch((error) => {
            this.setState({ loading: true });
            console.log(error);
            toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
            return null;
          });
      }
    } else {
      this.setState({ loading: true });
      AdsGetAll(this.state.page, this.state.rowsPerPage)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.success) {
            this.setState({ loading: false });
            this.setState({
              data: response.result,
              datalength: response.count,
            });
          } else {
            console.log(response.message);
            this.setState({ loading: true });
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading: true });
          toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
        });
    }
  };

  onFormSubmit(data) {
    if (data.key === "" || data.title === "") {
      if (data.key === "") {
        toast.error(" کلید وارد نشده است");
      }

      if (data.title === "") {
        toast.error(" عنوان وارد نشده است");
      }

      return false;
    }

    if (data.id !== "") {
      SettingUpdate(data)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          var query = this.state.data.find((q) => q.id === data.id);
          query.key = data.key;
          query.title = data.title;
          query.desc = data.desc;
          query.picUrl = data.picUrl;

          this.setState({ isAdd: true, isEdit: false });
          toast.success("عملیات با موفقیت انجام شد ...!");
          return null;
        })
        .catch((error) => {
          console.log(error);
          return null;
        });
    } else {
      data.id = "";
      SettingCreate(data)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.setState((prevState) => ({
            data: [...prevState.data, response.result],
          }));
          this.setState({ isAdd: true, isEdit: false });
          toast.success("عملیات با موفقیت انجام شد ...!");
          return null;
        })
        .catch((error) => {
          console.log(error);
          toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
          return null;
        });
    }
  }
  handleDelete1 = (id) => {
    if (id === "") {
      toast.warn("شناسه ای برای ادامه عملیات وجود ندارد");
      return;
    }
    confirmAlert({
      title: "توجه",
      message: "اطلاعات مورد نظر حذف خواهد شد",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            AdsDelete(id)
              .then((response) => {
                this.setState({
                  data: this.state.data.filter((item) => item.id !== id),
                });
                toast.success("اطلاعات مورد نظر حذف شد");
                return null;
              })
              .catch((error) => {
                console.log(error);
                toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
                return null;
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleDelete = (id) => {
    if (id === "") {
      toast.warn("شناسه ای برای ادامه عملیات وجود ندارد");
      return;
    }
    confirmAlert({
      title: "توجه",
      message: "آگهی مورد نظر تایید خواهد شد",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            Adsconfirm({ Id: id, IsConfirmed: true })
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                if (response.success) {
                  toast.success("آگهی با موفقیت تایید شد");
                  this.getList();
                } else {
                  toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
                }
                return null;
              })
              .catch((error) => {
                toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
                return null;
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };
  handleConfirmSearch = (e) => {
    this.setState({ loading: true });
    if (this.state.isConfirm || this.state.isNotConfirm) {
      if (this.state.townId) {
        this.setState({ loading: true });
        getAdvertismentByTownId2(
          this.state.townId,
          this.state.isConfirm,
          this.state.isNotConfirm,
          this.state.page,
          this.state.rowsPerPage
        )
          .then((response) => {
            this.setState({ loading: false });

            return response.json();
          })
          .then((responseJson) => {
            this.setState({ data: responseJson.result });
          })
          .catch((error) => {
            this.setState({ loading: false });
            console.log(error);
          });
      } else {
        SearchConfirmAds(
          this.state.isConfirm,
          this.state.isNotConfirm,
          this.state.page,
          this.state.rowsPerPage
        )
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.success) {
              this.setState({ loading: false });
              this.setState({ data: response.result });
            } else {
              this.setState({ loading: false });
              console.log(response.message);
              toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
            }
            return null;
          })
          .catch((error) => {
            this.setState({ loading: true });
            console.log(error);
            toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
            return null;
          });
      }
    } else {
      this.getrequest();
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getList();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getList();
    });
  };
  handleChangeCat = (event) => {
    this.setState({ townId: event.target.value }, () => {
      this.state.townId == "" ? this.getList() : this.getrequest();
    });
  };
  handleChangeProvince = (event) => {
    this.setState({ provinceId: event.target.value }, () => {
      this.state.provinceId === "" ? this.getList() : this.getAdsByProvince();
      this.getTowns();
      // this.getAdsByProvince();
      // this.getTowns();
    });
  };
  handleChangeConfirm = (event) => {
    this.setState({ isConfirm: event.target.checked }, () => {
      this.handleConfirmSearch();
    });
  };
  handleChangeNotConfirm = (event) => {
    this.setState({ isNotConfirm: event.target.checked }, () => {
      this.handleConfirmSearch();
    });
  };

  render() {
    // let setForm;
    // if (this.state.isAdd || this.state.isEdit) {
    //     setForm = <AddSetting onFormSubmit={this.onFormSubmit} fillData={this.state.existData} />
    // }

    return (
      <div>
        {/* <hr /> */}
        <div className="col-lg-12  mypanel shadow">
          <Header_panel
            title="لیست آگهی"
            idMenu="#navbarToggleExternalContentSettingList"
          />
          <div className="row">
            <div className=" col-lg-3  textg mt-3 ">
              <label className="control-label" htmlFor="provinceId">
                فیلتر بر اساس استان
              </label>
              <select
                // required
                className="form-control"
                name="provinceId"
                id="provinceId"
                value={this.provinceId}
                onChange={this.handleChangeProvince}
                // onClick={() =>
                // this.state.provinceId == ""
                //   ? this.getList()
                //   : this.getAdsByProvince()
                // }
              >
                <option value={""}>نمایش همه</option>
                {this.state.provinces &&
                  this.state.provinces.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className=" col-lg-3  textg  mt-3">
              <label
                className="control-label"
                htmlFor="categoryPost_CategoryId"
              >
                فیلتر بر اساس شهرک
              </label>
              <select
                // required
                className="form-control"
                name="townId"
                id="townId"
                value={this.townId}
                onChange={this.handleChangeCat}
                // onClick={() =>

                // }
              >
                <option value={""}>نمایش همه</option>
                {this.state.towns &&
                  this.state.towns.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-lg-2 mt-5">
              <label className=" form-control" htmlFor="isConfirm">
                {" "}
                تایید شده ها{" "}
                <span>
                  <input
                    type="checkbox"
                    id="isConfirm"
                    name="isConfirm"
                    checked={this.state.isConfirm}
                    onClick={(e) => this.handleChangeConfirm(e)}
                  />
                </span>
              </label>{" "}
            </div>
            <div className="col-lg-2 mt-5">
              <label className=" form-control" htmlFor="isNotConfirm">
                {" "}
                تایید نشده ها{" "}
                <span>
                  <input
                    type="checkbox"
                    id="isNotConfirm"
                    name="isNotConfirm"
                    checked={this.state.isNotConfirm}
                    onClick={(e) => this.handleChangeNotConfirm(e)}
                  />
                </span>
              </label>{" "}
            </div>
          </div>

          <div className="pos-f-t">
            <div className="row">
              <div className="col-lg-6  pt-4 ">
                <input
                  name="name"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  type="text"
                  class="form-control"
                  placeholder="نام  مورد نظر را وارد کنید ..."
                  aria-label=""
                  aria-describedby="basic-addon1"
                />
              </div>
              <span>
                {" "}
                <button
                  class="btn btn-outline-secondary mt-4"
                  type="button"
                  onClick={() => this.getList()}
                >
                  جستجو
                </button>
              </span>

              {/* <div class="col-lg-2 text-center">
                <label className="control-label" htmlFor="isDone">
                  تایید شده ها
                </label>
                <input
                  type="checkbox"
                  className="form-control"
                  id="isDone"
                  name="isDone"
                  checked={this.state.isDone}
                  onChange={(e) => this.setState({ isDone: e.target.checked })}
                  onClick={(e) => this.handleConfirmSearch(e)}
                />
              </div> */}
            </div>

            <div
              className="collapse"
              id="navbarToggleExternalContentSettingList"
            >
              <div className="p-4 mytable">
                <table className="table table-striped rtltable">
                  <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>نام کاربر </th>
                      <th>عنوان</th>
                      <th>شماره تلفن</th>
                      <th> تایید شده</th>

                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data &&
                      this.state.data.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          {/* <td>
                                                    {
                                                        item.picUrl
                                                            ?
                                                            <img src={`http://maloosjan.ir/${item.picUrl}`} alt="raeen" width="80" />
                                                            :
                                                            <img src={NoImage} alt="NoImage" width="80" />
                                                    }
                                                </td> */}
                          <td>{item.userName ? item.userName : "----"}</td>
                          <td>{item.title ? item.title : "----"}</td>
                          <td>{item.phone ? item.phone : "----"}</td>
                          {item.isConfirmed ? (
                            <CheckCircleOutlineIcon
                              style={{ color: "green" }}
                            />
                          ) : item.isConfirmed == false &&
                            !item.rejectingReason ? (
                            "در حال بررسی"
                          ) : (
                            <HighlightOffIcon style={{ color: "red" }} />
                          )}
                          <td>
                            <ModalDetailAds
                              buttonLabel="توضیحات"
                              title="توضیحات"
                              pic={item.imageUrl}
                              userName={item.userName}
                              mobile1={
                                item.mobile1
                                  ? item.mobile1
                                  : "شماره تماس ادمین شهرک ثبت نشده است"
                              }
                              mobile2={
                                item.mobile2
                                  ? item.mobile2
                                  : "شماره تماس ادمین شهرک ثبت نشده است"
                              }
                              phone={
                                item.phone
                                  ? item.phone
                                  : "شماره تماس  ثبت نشده است"
                              }
                              description={
                                item.description
                                  ? item.description
                                  : "توضیحات ثبت نشده است"
                              }
                              adsCategoryName={
                                item.adsCategoryName
                                  ? item.adsCategoryName
                                  : "دسته بندی ثبت نشده است"
                              }
                              address={
                                item.address
                                  ? item.address
                                  : "آدرس ثبت نشده است"
                              }
                              customerName={
                                item.customerName ? item.customerName : "----"
                              }
                              createDateTime={
                                item.createDateTime
                                  ? item.createDateTime
                                  : "تاریخ ثبت نشده است"
                              }
                              townName={
                                item.townName
                                  ? item.townName
                                  : "شهرک ثبت نشده است"
                              }
                              provinceName={
                                item.provinceName
                                  ? item.provinceName
                                  : "استان ثبت نشده است"
                              }
                              rejectingReason={
                                item.rejectingReason
                                  ? item.rejectingReason
                                  : "دلیل رد آگهی ثبت نشده است"
                              }
                            ></ModalDetailAds>
                          </td>
                          <td>
                            {" "}
                            <button
                              disabled={item.isConfirmed}
                              className="btn btn-success"
                              id="regDelbtn"
                              onClick={() => {
                                this.handleDelete(item.id);
                              }}
                            >
                              تایید
                            </button>
                          </td>
                          <td>
                            <ModalUpdate
                              reason={item.rejectingReason}
                              confirm={item.isConfirmed}
                              buttonLabel="رد"
                              title="رد"
                              id={item.id}
                              getlist={this.getList}
                            />
                          </td>
                          <td>
                            {" "}
                            <button
                              className="btn btn-warning"
                              id="regDelbtn"
                              onClick={() => {
                                this.handleDelete1(item.id);
                              }}
                            >
                              حذف
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {this.state.loading && (
          <CircularProgress size={30} className="buttonProgress" />
        )}
        <TablePagination
          // style={{ direction: "rtl" }}
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={this.state.datalength}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          backIconButtonProps={{
            "aria-label": "previous page",
          }}
          nextIconButtonProps={{
            "aria-label": "next page",
          }}
          labelRowsPerPage="تعداد نمایش :"
          nextIconButtonText="بعدی"
          backIconButtonText="قبلی"
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export class ModalUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      id: "",
      RejectingReason: "",
      IsConfirmed: "",
    };

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount = () => {};

  toggle() {
    this.setState({ modal: !this.state.modal, id: this.props.id });
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSubmit = () => {
    if (this.state.RejectingReason === "") {
      toast.warn("لطفا دلیل رد آگهی را وارد نمایید");
      return;
    }

    Adsconfirm({
      Id: this.props.id,
      IsConfirmed: false,
      RejectingReason: this.state.RejectingReason,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.success) {
          toast.success("آگهی با موفقیت لغو شد");
          // this.props.getList();
          window.location.reload();
          this.setState({ RejectingReason: "" });
        } else {
          // toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
        }
        return null;
      })
      .catch((error) => {
        // toast.error("خطای سمت سرور با پشتیبانی تماس بگیرید");
        return null;
      });
  };

  render() {
    return (
      <div>
        <button
          className="btn btn-danger"
          disabled={!this.props.confirm && !this.props.reason == ""}
          onClick={this.toggle}
        >
          {this.props.buttonLabel}
        </button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <Form onSubmit={this.handleSubmit}>
            <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
            <ModalBody style={{ textAlign: "right" }}>
              <div className="row p-4">
                <div className="col-lg-12">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="RejectingReason">
                      *دلیل رد آگهی
                    </label>
                    <textarea
                      rows="2"
                      value={this.state.RejectingReason}
                      onChange={this.handleChange("RejectingReason")}
                      className="contactInput form-control"
                      name="RejectingReason"
                      placeholder="دلیل رد آگهی..."
                    />
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggle}>
                بستن
              </Button>
              <Button
                color="primary"
                id="regProdbtn"
                onClick={() => this.handleSubmit()}
              >
                ذخیره
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    );
  }
}
